export var UserGiftInitStatus = /*#__PURE__*/ function(UserGiftInitStatus) {
    UserGiftInitStatus["Loading"] = "loading";
    UserGiftInitStatus["Initialized"] = "initialized";
    UserGiftInitStatus["FailedToInitialize"] = "failed-to-initialize";
    return UserGiftInitStatus;
}({});

//# sourceMappingURL=types.js.map